<div
  [class]="circleClass"
  [ngStyle]="{ 'background-color': getThemeColors().backgroundColor }"
>
  <div
    [class]="iconClass"
    [ngStyle]="{ color: getThemeColors().iconColor }"
  ></div>
</div>
